<template>
    <div>
        <div class="detail-data-wrapper mb-4">
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label"><strong>No. Faktur</strong></b-col>
                <b-col v-if="detailGadai.noFaktur != null">
                    <strong>{{ detailGadai.noFaktur }}</strong>
                    <b-badge variant="info" class="ml-2" v-if="detailGadai.counterPerpanjangan && detailGadai.counterPerpanjangan > 0">
                        Perpanjangan ke-{{ detailGadai.counterPerpanjangan }} dari {{ detailGadai.maxPerpanjangan || 4 }}
                    </b-badge>
                </b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2" v-if="detailGadai.parentNoFaktur">
                <b-col cols="4" class="detail-data-label">Gadai Asal (Rollover)</b-col>
                <b-col>
                    <b-badge variant="secondary" style="font-size: 12px; font-weight: 600; padding: 4px 8px;">
                        <i class="fa fa-link mr-1"></i> Rollover dari {{ detailGadai.parentNoFaktur }}
                    </b-badge>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Status Gadai</b-col>
                <b-col v-if="detailGadai.statusGadai != null">{{ detailGadai.statusGadai }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Posisi Barang</b-col>
                <b-col v-if="detailGadai.posisiBarang != null">{{ detailGadai.posisiBarang }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
        </div>

        <div class="detail-data-wrapper mb-4">
            <h6 class="form-title">DATA ANGGOTA</h6>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">No. Anggota</b-col>
                <b-col v-if="detailGadai.anggota.noAnggota != null"><strong>{{ detailGadai.anggota.noAnggota }}</strong></b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Jenis Identitas</b-col>
                <b-col v-if="detailGadai.anggota.jenisIdentitas != null">{{ detailGadai.anggota.jenisIdentitas }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">No. Identitas</b-col>
                <b-col v-if="detailGadai.anggota.noIdentitas != null">{{ detailGadai.anggota.noIdentitas }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Nama</b-col>
                <b-col v-if="detailGadai.anggota.namaAnggota != null">{{ detailGadai.anggota.namaAnggota }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Alamat</b-col>
                <b-col v-if="detailGadai.anggota.alamat != null">{{ detailGadai.anggota.alamat }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">No. Handphone</b-col>
                <b-col v-if="detailGadai.anggota.noHp != null">{{ detailGadai.anggota.noHp }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">No. Rumah</b-col>
                <b-col v-if="detailGadai.anggota.noRumah != null">{{ detailGadai.anggota.noRumah }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
        </div>

        <div v-if="detailGadai.barang.kendaraan == null" class="detail-data-wrapper mb-4">
            <h6 class="form-title">DATA BARANG</h6>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Jenis Barang</b-col>
                <b-col v-if="detailGadai.barang.jenis != null">{{ detailGadai.barang.jenis.name }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Merk Barang</b-col>
                <b-col v-if="detailGadai.barang.merk != null">{{ detailGadai.barang.merk.name }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Tipe Barang</b-col>
                <b-col v-if="detailGadai.barang.tipe != null">{{ detailGadai.barang.tipe.name }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Tahun</b-col>
                <b-col v-if="detailGadai.barang.tahun != null">{{ detailGadai.barang.tahun }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row v-if="detailGadai.barang.kendaraan == null" class="mb-2">
                <b-col cols="4" class="detail-data-label">No. Imei/ SN</b-col>
                <b-col v-if="detailGadai.barang.noImei != null">{{ detailGadai.barang.noImei }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Password</b-col>
                <b-col v-if="detailGadai.barang.password != null">{{ detailGadai.barang.password }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Grade Barang</b-col>
                <b-col v-if="detailGadai.barang.gradeKondisi != null">{{ detailGadai.barang.gradeKondisi.name }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Warna</b-col>
                <b-col v-if="detailGadai.barang.warna != null">{{ detailGadai.barang.warna.name }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Kelengkapan Barang</b-col>
                <b-col v-if="detailGadai.barang.kelengkapan.length >= 1">
                    <ul class="list-circle-wrapper">
                        <li v-for="item in detailGadai.barang.kelengkapan"  v-bind:key="item">
                            {{ item }}
                        </li>
                    </ul>
                </b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Spesifikasi Barang</b-col>
                <b-col v-if="detailGadai.barang.spesifikasi.length >= 1">
                    <ul class="list-circle-wrapper">
                        <li v-for="(item, idx) in detailGadai.barang.spesifikasi"  v-bind:key="idx">
                            {{ item.name }}
                        </li>
                    </ul>
                </b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Kondisi/Kerusakan/Keterangan Lainnya</b-col>
                <b-col v-if="$helper.isNotNullAndNotEmpty(detailGadai.barang.keterangan)">{{ detailGadai.barang.keterangan }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>

            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Foto</b-col>
                <b-col v-if="$helper.isNotNullAndNotEmpty(detailGadai.foto)">
                    <span class="mr-1" v-for="(item, idx) in detailGadai.foto"  v-bind:key="idx">
                        <a v-bind:href="$baseFilePath + item" target="_blank">
                            <img width="150px" :src="$baseFilePath + item" alt="Foto Pendukung 3">
                        </a>
                    </span>
                </b-col>
                <b-col v-else>-</b-col>
            </b-row>
        </div>

        <div v-if="detailGadai.barang.kendaraan != null" class="detail-data-wrapper mb-4">
            <h6 class="form-title">DATA KENDARAAN</h6>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Tipe Pinjaman</b-col>
                <b-col v-if="detailGadai.barang.withKendaraan == true">Kendaraan + BPKB</b-col>
                <b-col v-else>BPKB Saja</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Jenis Kendaraan</b-col>
                <b-col v-if="detailGadai.barang.jenis != null">{{ detailGadai.barang.jenis.name }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">No. Polisi</b-col>
                <b-col v-if="detailGadai.barang.kendaraan.noPolisi != null">{{ detailGadai.barang.kendaraan.noPolisi }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Merk</b-col>
                <b-col v-if="detailGadai.barang.merk != null">{{ detailGadai.barang.merk.name }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Tipe</b-col>
                <b-col v-if="detailGadai.barang.tipe != null">{{ detailGadai.barang.tipe.name }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Tahun</b-col>
                <b-col v-if="detailGadai.barang.tahun != null">{{ detailGadai.barang.tahun }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Kondisi</b-col>
                <b-col v-if="detailGadai.barang.gradeKondisi != null">{{ detailGadai.barang.gradeKondisi.name }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Warna</b-col>
                <b-col v-if="detailGadai.barang.warna != null">{{ detailGadai.barang.warna.name }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Kelengkapan Barang</b-col>
                <b-col v-if="detailGadai.barang.kelengkapan.length >= 1">
                    <ul class="list-circle-wrapper">
                        <li v-for="item in detailGadai.barang.kelengkapan"  v-bind:key="item">
                            {{ item }}
                        </li>
                    </ul>
                </b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Status</b-col>
                <b-col v-if="detailGadai.barang.kendaraan.status != null">{{ detailGadai.barang.kendaraan.status }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Spesifikasi Barang</b-col>
                <b-col v-if="detailGadai.barang.spesifikasi.length >= 1">
                    <ul class="list-circle-wrapper">
                        <li v-for="(item, idx) in detailGadai.barang.spesifikasi"  v-bind:key="idx">
                            {{ item.name }}
                        </li>
                    </ul>
                </b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Foto</b-col>
                <b-col v-if="$helper.isNotNullAndNotEmpty(detailGadai.foto)">
                    <span class="mr-1" v-for="(item, idx) in detailGadai.foto"  v-bind:key="idx">
                        <a v-bind:href="$baseFilePath + item" target="_blank">
                            <img width="150px" :src="$baseFilePath + item" alt="Foto Pendukung 3">
                        </a>
                    </span>
                </b-col>
                <b-col v-else>-</b-col>
            </b-row>
        </div>

        <div v-if="detailGadai.barang.kendaraan != null" class="detail-data-wrapper mb-4">
            <h6 class="form-title">DATA STNK</h6>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">STNK Atas Nama</b-col>
                <b-col v-if="detailGadai.barang.kendaraan.namaSTNK != null">{{ detailGadai.barang.kendaraan.namaSTNK }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Alamat STNK</b-col>
                <b-col v-if="detailGadai.barang.kendaraan.alamatSTNK != null">{{ detailGadai.barang.kendaraan.alamatSTNK }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Masa Berlaku Pajak</b-col>
                <b-col v-if="detailGadai.barang.kendaraan.pajakSTNK != null">{{$helper.changeDateFormat(detailGadai.barang.kendaraan.pajakSTNK)}}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
        </div>

        <div v-if="detailGadai.barang.kendaraan != null" class="detail-data-wrapper mb-4">
            <h6 class="form-title">DATA BPKB</h6>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">No. BPKB</b-col>
                <b-col v-if="detailGadai.barang.kendaraan.noBPKB != null">{{ detailGadai.barang.kendaraan.noBPKB }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">BPKB Atas Nama</b-col>
                <b-col v-if="detailGadai.barang.kendaraan.namaBPKB != null">{{ detailGadai.barang.kendaraan.namaBPKB }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">No. Mesin</b-col>
                <b-col v-if="detailGadai.barang.kendaraan.noMesin != null">{{ detailGadai.barang.kendaraan.noMesin }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">No. Rangka</b-col>
                <b-col v-if="detailGadai.barang.kendaraan.noRangka != null">{{ detailGadai.barang.kendaraan.noRangka }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
        </div>

        <div class="detail-data-wrapper mb-4">
            <h6 class="form-title">DATA PINJAMAN</h6>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Cabang Penggadaian</b-col>
                <b-col v-if="detailGadai.cabangPenggadaian != null">{{ detailGadai.cabangPenggadaian.name }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Tanggal Gadai</b-col>
                <b-col v-if="detailGadai.tanggalGadai != null">{{$helper.changeDateFormat(detailGadai.tanggalGadai)}}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Tanggal Jatuh Tempo</b-col>
                <b-col v-if="detailGadai.tanggalJatuhTempo != null">{{$helper.changeDateFormat(detailGadai.tanggalJatuhTempo)}}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">
                    Pinjaman Pokok Awal
                    <i class="fa fa-info tooltip-trigger-btn ml-1" id="tooltip-pinjaman-awal"></i>
                </b-col>
                <b-tooltip target="tooltip-pinjaman-awal" triggers="hover">
                    Nominal pinjaman yang diambil nasabah saat penggadaian dilakukan.
                </b-tooltip>
                <b-col v-if="detailGadai.pinjamanPokokAwal != null">Rp. {{$helper.addThousandSeparator(detailGadai.pinjamanPokokAwal)}}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">
                    Pinjaman Pokok Efektif
                    <i class="fa fa-info tooltip-trigger-btn ml-1" id="tooltip-pinjaman-efektif"></i>
                </b-col>
                <b-tooltip target="tooltip-pinjaman-efektif" triggers="hover">
                    Nominal pinjaman pokok tersisa sekarang (bila ada angsuran pokok)
                </b-tooltip>
                <b-col v-if="detailGadai.pinjamanPokokEfektif != null">Rp. {{$helper.addThousandSeparator(detailGadai.pinjamanPokokEfektif)}}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Harga Barang</b-col>
                <b-col v-if="detailGadai.hargaBarang != null">Rp. {{$helper.addThousandSeparator(detailGadai.hargaBarang)}}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Harga Admin Awal</b-col>
                <b-col v-if="detailGadai.hargaAdminAwal != null">Rp. {{$helper.addThousandSeparator(detailGadai.hargaAdminAwal)}}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Jasa Awal</b-col>
                <b-col v-if="detailGadai.jasaAwal != null">Rp. {{$helper.addThousandSeparator(detailGadai.jasaAwal)}}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Promo</b-col>
                <b-col v-if="detailGadai.promo.length !=  0">
                    <ul class="list-circle-wrapper">
                        <li v-for="(item, idx) in detailGadai.promo"  v-bind:key="idx">
                            {{ item }}
                        </li>
                    </ul>
                </b-col>
                <b-col v-else>-</b-col>
            </b-row>
        </div>

        <div class="detail-data-wrapper mb-4">
            <h6 class="form-title">HISTORI PEMBAYARAN</h6>
            <b-table bordered hover show-empty :fields="field" :items="detailGadai.pembayaran" responsive class="mb-3">
                <template v-slot:empty>
                    Tidak ada data histori pembayaran.
                </template>
                <template v-slot:cell(tanggalPembayaran)="row">
                    <p class="mb-0">{{$helper.changeDateFormat(row.item.tanggalPembayaran)}}</p>
                    <p class="mb-0 smallText text-muted">{{row.item.cabangPembayaran}}</p>
                </template>
                <template v-slot:cell(jenisPembayaran)="row">
                    <div>
                        <div>
                            <p class="mb-0">{{row.item.jenisPembayaran}}</p>
                        </div>
                        <div>
                            <span class="smallText text-muted" v-if="row.item.pembayaranTunai == true">Tunai </span>
                            <span class="smallText text-muted" v-else>Transfer</span>
                            <span class="smallText text-muted"> - {{row.item.statusPembayaran}}</span>
                        </div>
                    </div>
                </template>
                <template v-slot:cell(nominalPembayaran)="row">
                    <div class="text-right no-wrap" v-if="row.item.nominalPembayaran == null">{{$helper.addThousandSeparator(row.item.nominalPembayaran)}} </div>
                    <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.nominalPembayaran)}} </div>
                </template>
                <template v-slot:cell(angsuranPokok)="row">
                    <div class="text-right no-wrap" v-if="row.item.angsuranPokok == null">{{$helper.addThousandSeparator(row.item.angsuranPokok)}} </div>
                    <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.angsuranPokok)}} </div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge variant="dark" v-if="row.item.status == 'Baru'">BARU</b-badge>
                    <b-badge variant="success" v-else-if="row.item.status == 'Terbayar'">TERBAYAR</b-badge>
                    <b-badge variant="danger" v-else-if="row.item.status == 'Void'">VOID</b-badge>
                    <b-badge variant="warning" v-else-if="row.item.status == 'Request Void'">REQUEST VOID</b-badge>
                    <b-badge v-else>{{ row.item.status }}</b-badge>   
                </template>
                <template v-slot:head(status)>
                    Status 
                    <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-button size="sm" class="table-button view" v-b-tooltip.hover title="Detail" name="historyBayarViewBtn" @click="viewHistoryBayar(row.item.id)">
                            <i class="fa fa-info"></i>
                        </b-button>
                    </div>
                </template>
            </b-table>
        </div>
        <b-modal id="modal-detail-historyBayar" title="Detail History Pembayaran" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA TRANSAKSI</h6>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label"><strong>No. Kwitansi</strong></b-col>
                    <b-col v-if="singleDetailPembayaran.noKwitansi != null"><strong>{{ singleDetailPembayaran.noKwitansi }}</strong></b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Cabang</b-col>
                    <b-col v-if="singleDetailPembayaran.cabangPembayaran != null">{{ singleDetailPembayaran.cabangPembayaran }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Status</b-col>
                    <b-col v-if="singleDetailPembayaran.status != null">{{ singleDetailPembayaran.status }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Status Pembayaran</b-col>
                    <b-col v-if="singleDetailPembayaran.statusPembayaran != null">{{ singleDetailPembayaran.statusPembayaran }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Jenis Pembayaran</b-col>
                    <b-col v-if="singleDetailPembayaran.jenisPembayaran != null">{{ singleDetailPembayaran.jenisPembayaran }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Metode Pembayaran</b-col>
                    <b-col v-if="singleDetailPembayaran.pembayaranTunai == true">Tunai</b-col>
                    <b-col v-else>Transfer</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Tanggal Pembayaran</b-col>
                    <b-col v-if="singleDetailPembayaran.tanggalPembayaran != null">{{$helper.changeDateFormat(singleDetailPembayaran.tanggalPembayaran)}}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title">RINCIAN PEMBAYARAN</h6>
                <b-row class="mb-2" v-for="(item, idx) in dataDetailPembayaran.detail"  v-bind:key="idx">
                    <b-col cols="5" class="detail-data-label">{{item.name}}</b-col>
                    <b-col v-if="item.nominal == null">{{$helper.addThousandSeparator(item.nominal)}} </b-col>
                    <b-col v-else>Rp. {{$helper.addThousandSeparator(item.nominal)}} </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Angsuran Pokok</b-col>
                    <b-col v-if="dataDetailPembayaran.angsuranPokok == null">{{$helper.addThousandSeparator(dataDetailPembayaran.angsuranPokok)}} </b-col>
                    <b-col v-else>Rp. {{$helper.addThousandSeparator(dataDetailPembayaran.angsuranPokok)}} </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Total Pembayaran</b-col>
                    <b-col v-if="dataDetailPembayaran.nominalPembayaran == null">{{$helper.addThousandSeparator(dataDetailPembayaran.nominalPembayaran)}} </b-col>
                    <b-col v-else>Rp. {{$helper.addThousandSeparator(dataDetailPembayaran.nominalPembayaran)}} </b-col>
                </b-row>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">BARU</h6>
                <p class="smallText mb-0">Transaksi gadai yang baru diinput dan belum ditransaksikan. Seluruh gadai BARU yang tidak dieksekusi, akan dihapus keesokan harinya.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">BERJALAN</h6>
                <p class="smallText mb-0">Transaksi gadai aktif yang sudah dieksekusi dan dicetak SBGnya.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">VOID</h6>
                <p class="smallText mb-0">Transaksi gadai sudah digugurkan (VOID).</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">LUNAS</h6>
                <p class="smallText mb-0">Transaksi gadai sudah lunas.</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'detail-gadai',
    props: {
        detailGadai: { type: Object, required: true }
    },
    data() {
        return {
            field: [
                { key: "noKwitansi", label: "No. Kwitansi", sortable: true },
                { key: "tanggalPembayaran", label: "Tanggal Pembayaran" },
                { key: "jenisPembayaran", label: "Jenis Pembayaran" },
                { key: "angsuranPokok", label: "Angsuran Pokok" },
                { key: "nominalPembayaran", label: "Total Pembayaran" },
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi" },
            ],
            singleDetailPembayaran: {},
            dataDetailPembayaran: []
        }
    },
    methods: {
        viewHistoryBayar(id){
            console.log(id)

            this.$axios.get("gadai-pembayaran/"+id).then(response => {
                this.dataDetailPembayaran = response.data
                console.log(response.data)
                let idx = this.detailGadai.pembayaran.findIndex(item => item.id == id);
                this.singleDetailPembayaran = this.detailGadai.pembayaran[idx]
                console.log(this.singleDetailPembayaran)

                this.$bvModal.show("modal-detail-historyBayar")
            })

            
        }
    }
}
</script>